var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 194,
    viewBox: "0 0 516 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494.674 150.336L468.879 114.422L442.886 150.336H422.052L458.561 100.136L423.044 51.5228H443.878L468.879 86.2463L493.682 51.5228H514.516L479.197 100.532L515.508 150.336H494.674Z",
    fill: "#ABABB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.531 131.288V70.5711L324.579 51.5228H363.072L377.755 64.4201V8.6642H396.209V150.336H378.549V133.272L361.485 150.336H324.579L305.531 131.288ZM358.509 134.264L377.755 114.819V82.8731L360.493 67.5948H333.111L323.984 76.7221V125.137L333.111 134.264H358.509Z",
    fill: "#ABABB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8578 67.3964H0V51.5228H17.8578V30.2919L36.1124 12.0373H67.2642V27.7125H44.0491L36.3108 35.4508V51.5228H67.2642V67.3964H36.3108V150.336H17.8578V67.3964Z",
    fill: "#ABABB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.899 150.402L186.104 114.488L160.111 150.402H139.277L175.786 100.202L140.269 51.5893H161.103L186.104 86.3127L210.907 51.5893H231.741L196.422 100.599L232.733 150.402H211.899Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2536 0H132.754V16.8284H107.314V177.009H132.754V193.838H89.2536V0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.591 193.838V177.009H264.837V16.8284H239.591V0H283.091V193.838H239.591Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoLight);
export default __webpack_public_path__ + "static/media/NEW_LOGO_LIGHT.f71124b6d8ebad616069b86f6a24c249.svg";
export { ForwardRef as ReactComponent };